import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { MultiStyleType } from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

import { REFER_BUTTON_CLASS_NAME } from '../ReferButton'
import {
  hiddenRowActionStyle,
  revealedRowActionStyle,
  rowActionRevealSelector,
} from './rowActionReveal'

export const enum ParkTargetVariants {
  Default = 'default',
  Available = 'available',
  Unavailable = 'unavailable',
}

const parkTargetParts = [
  'container',
  'presenceBadge',
  'text',
  'button',
  'buttonText',
] as const

const helpers = createMultiStyleConfigHelpers(parkTargetParts)

export const ParkTargetStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      height: '3.875rem',
      width: 'full',
      paddingY: '0.75rem',
      paddingX: '1.25rem',
      gap: '0.75rem',
      justifyContent: 'flex-start',
      alignItems: 'center',
      borderRadius: '0.5rem',
      backgroundColor: 'transparent',
      position: 'relative',
      _hover: {
        backgroundColor: 'bg.muted',
      },
      _focusWithin: {
        backgroundColor: 'bg.muted',
      },
      [rowActionRevealSelector(REFER_BUTTON_CLASS_NAME)]:
        revealedRowActionStyle,
    },
    text: {
      minWidth: 0,
      ...textStyles[textStyleKeys.Body1],
    },
    button: {
      height: '2.375rem',
      paddingY: '0.625rem',
      paddingX: '1.125rem',
      backgroundColor: 'blue.solid',
      borderRadius: '100px',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      display: 'flex',
      flexShrink: 0,
      ...hiddenRowActionStyle,
      _focusVisible: {
        outline: '2px solid',
        outlineColor: 'brand.fg',
        outlineOffset: '2px',
      },
    },
    buttonText: {
      color: 'fg.inverted',
      ...textStyles[textStyleKeys.Body2_Semibold],
    },
  },
  variants: {
    [ParkTargetVariants.Default]: {},
    [ParkTargetVariants.Available]: {},
    [ParkTargetVariants.Unavailable]: {},
  },
  defaultProps: {},
})

export const useParkTargetStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(ParkTargetStyle, props) as MultiStyleType<
    typeof parkTargetParts
  >
}
